<template>
  <v-dialog
    :value="value"
    persistent
    max-width="26rem"
    content-class="invoice-started-dialog"
    :style="{ zIndex: 200 }"
  >
    <v-card class="invoice-started-card">
      <v-btn
        icon
        class="invoice-started-close"
        title="Close"
        @click.prevent="$emit('input', false)"
      >
        <v-icon>close</v-icon>
      </v-btn>

      <div class="invoice-started-icon" aria-hidden="true">
        <v-icon>hourglass_top</v-icon>
      </div>
      <h2 class="invoice-started-title">Invoice generation started</h2>
      <p class="invoice-started-copy">
        This runs in the background. We'll notify you once it is completed.
      </p>

      <v-btn
        class="invoice-started-ok oms-btn oms-btn--primary"
        @click="$emit('input', false)"
        >Got it</v-btn
      >
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "InvoiceStartedDialog",
  props: {
    /* v-model, controls visibility */
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style>
.application .v-dialog.invoice-started-dialog {
  border-radius: 1rem !important;
  max-width: min(26rem, calc(100vw - 2rem)) !important;
  width: min(26rem, calc(100vw - 2rem)) !important;
}

.application .v-dialog.invoice-started-dialog .invoice-started-card {
  align-items: center;
  border-radius: 1rem !important;
  display: flex;
  flex-direction: column;
  padding: 2rem 1.75rem 1.5rem;
  position: relative;
  text-align: center;
}

.application .v-dialog.invoice-started-dialog .invoice-started-close.v-btn {
  height: 2rem !important;
  margin: 0;
  position: absolute;
  right: 0.75rem;
  top: 0.75rem;
  width: 2rem !important;
}

.application .v-dialog.invoice-started-dialog .invoice-started-close .v-icon {
  color: var(--oms-muted) !important;
  font-size: 1.25rem;
}

.application .v-dialog.invoice-started-dialog .invoice-started-icon {
  align-items: center;
  background: var(--oms-primary-soft);
  border: 0.0625rem solid var(--oms-peach-border);
  border-radius: 50%;
  display: flex;
  height: 3.5rem;
  justify-content: center;
  margin-bottom: 1rem;
  width: 3.5rem;
}

.application .v-dialog.invoice-started-dialog .invoice-started-icon .v-icon {
  color: var(--oms-primary) !important;
  font-size: 1.75rem;
}

.application .v-dialog.invoice-started-dialog .invoice-started-title {
  color: var(--oms-ink-strong);
  font-size: 1.0625rem;
  font-weight: 800;
  line-height: 1.3;
  margin: 0 0 0.375rem;
}

.application .v-dialog.invoice-started-dialog .invoice-started-copy {
  color: var(--oms-muted);
  font-size: 0.875rem;
  line-height: 1.45;
  margin: 0 0 1.375rem;
  max-width: 20rem;
}

.application .v-dialog.invoice-started-dialog .invoice-started-ok.v-btn {
  margin: 0;
  min-width: 8rem !important;
}
</style>
